/* eslint-disable react/jsx-one-expression-per-line */
import { Button } from '@storybook';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { jackActiveStepsState } from 'states';
import './verification-auth.scss';
import userAvatarImg from '../../views/face-auth/asests/user_avatar.png';
import { jackRecipientDetails } from './states/jackstate';

export const JackRecipientDetailsScreen = () => {
	const setJackActiveSteps = useSetRecoilState(jackActiveStepsState);
	const jackRecipient = useRecoilValue(jackRecipientDetails);
	const [location, setLocation] = useState('--');

	const { user, customer } = jackRecipient ?? {};

	const BtnClick = useCallback(() => {
		setJackActiveSteps('sender-verification-screen');
	}, []);

	const renderStatus = useMemo(() => {
		if (customer?.status === 'rejected') {
			return 'Note: Recipient authentication failed';
		} else if (customer?.status === 'declined') {
			return 'Note: Recipient declined your request';
		}
		return '';
	}, []);

	useEffect(() => {
		fetch(
			'https://nominatim.openstreetmap.org/reverse?format=json&lat=' +
				customer?.device_info?.location?.latitude +
				'&lon=' +
				customer?.device_info?.location?.longitude
		)
			.then((response) => response.json())
			.then((data) => {
				if (data) {
					setLocation(data.display_name);
				}
			})
			.catch(() => {
				// handle error
				setLocation('--');
			});
	}, [customer]);

	const handleDisable = useMemo(() => {
		if (customer?.status === 'rejected' || customer?.status === 'declined') {
			return true;
		}
		return false;
	}, []);

	const renderImage = useMemo(() => {
		return (
			<img
				className="jack-recipitent-img"
				src={customer?.user_image === '' ? userAvatarImg : customer?.user_image}
				alt="img"
			/>
		);
	}, [customer]);

	return (
		<div className="jack-recipient-wrapper">
			<div className="jack-recipient-heading">Recipient Details</div>
			{renderImage}

			<div className="jack-info-wrapper">
				<div className="jack-info-label">Name :</div>{' '}
				<div>{user?.name ?? '--'}</div>
			</div>
			<div className="jack-info-wrapper">
				<div className="jack-info-label">Email :</div>
				<div>{user?.email_id ?? '--'}</div>
			</div>
			<div className="jack-info-wrapper">
				<div className="jack-info-label">Phone :</div>
				<div>{user?.phone_no ?? '--'}</div>
			</div>
			<div className="jack-info-wrapper">
				<div className="jack-info-label">Location :</div>
				<div data-tooltip={location}>
					<div className="jack-location-label">{location ?? '--'}</div>
				</div>
			</div>
			<div className="jack-recipient-status-note">{renderStatus}</div>
			<Button
				width="350px"
				handleClick={BtnClick}
				label={'Continue'}
				type="button__filled--primary button__large button__block button-jack-infor"
				disabled={handleDisable}
			></Button>
		</div>
	);
};
